export const testingJobs = [
  {
    title: "AI Engineer",
    location: "Lahore, Pakistan",
    description: `
    We are looking for a highly driven and experienced <b>AI Engineer</b> to join our growing team. As an AI Engineer, you will design and deploy machine learning models and data-driven solutions to solve real-world business challenges. You will work closely with our data science and engineering teams to develop innovative AI solutions that drive business value and competitive advantage. This role requires a deep understanding of machine learning algorithms, data processing techniques, and software engineering principles. You will be responsible for building scalable AI systems, optimizing model performance, and ensuring the successful deployment of AI solutions in production environments.<br /><br />
    <b>Key Responsibilities:</b>
    <ul>
      <li>Design, develop, and manage scalable data pipelines for large and complex datasets.</li>
      <li>Collaborate with cross-functional teams to translate business problems into AI/ML solutions.</li>
      <li>Build, deploy, and maintain machine learning models in production environments.</li>
      <li>Work with structured and unstructured data (APIs, databases, streaming, etc.).</li>
      <li>Optimize performance, scalability, and efficiency of ML models and data workflows.</li>
      <li>Develop APIs/microservices to integrate AI models into web and mobile applications.</li>
      <li>Monitor, retrain, and improve deployed models regularly.</li>
      <li>Ensure best practices in versioning, reproducibility, and testing of ML workflows.</li>
      <li>Document all processes, pipelines, and models with clarity and precision.</li>
    </ul>
    <b>Required Qualifications:</b>
    <ul>
      <li>Bachelor's or Master's degree in Computer Science, Artificial Intelligence, Data Science, or related field.</li>
      <li>Minimum 2 years of experience in data science, machine learning, or AI engineering.</li>
      <li>Strong analytical thinking and problem-solving skills.</li>
      <li>Excellent communication and teamwork abilities.</li>
    </ul>
    <b>Technical Skill Set:</b>
    <ul>
      <li><b>Languages:</b> Python, SQL, Java, Scala</li>
      <li><b>Data Handling:</b> Pandas, NumPy, PySpark, Dask</li>
      <li><b>Machine Learning:</b> Scikit-learn, TensorFlow, PyTorch</li>
      <li><b>Big Data:</b> Apache Spark, Hadoop</li>
      <li><b>Cloud Platforms:</b> AWS, Google Cloud, Azure</li>
      <li><b>DevOps/MLOps:</b> Docker, Kubernetes, MLflow, Airflow</li>
      <li><b>Databases:</b> MySQL, PostgreSQL, MongoDB, Cassandra</li>
    </ul>
    <br />
    <div class="apply-instructions">The candidates fulfilling the above mentioned criteria are encouraged to send their updated resumes at <a href="mailto:careers@trbai.com">careers@trbai.com</a>.</div><br><br>`
  },
  {
    title: "Data Scientist",
    location: "Lahore, Pakistan",
    description: `
    We are seeking a passionate <b>Data Scientist</b> to extract insights from large datasets and help drive data-driven decision making. In this role, you will be responsible for analyzing complex data sets, developing predictive models, and creating actionable insights that support strategic business decisions. You will work closely with stakeholders across different departments to understand business needs and translate them into analytical solutions. The ideal candidate will have a strong foundation in statistics, machine learning, and data visualization, along with the ability to communicate complex findings in a clear and compelling manner to both technical and non-technical audiences.<br /><br />
    <b>Key Responsibilities:</b>
    <ul>
      <li>Analyze large, complex datasets to identify trends and actionable insights.</li>
      <li>Develop predictive models and machine learning algorithms.</li>
      <li>Visualize data and communicate findings to stakeholders.</li>
      <li>Work closely with engineering and product teams to implement data solutions.</li>
      <li>Validate and tune models for accuracy and performance.</li>
      <li>Document methodologies and results.</li>
    </ul>
    <b>Required Qualifications:</b>
    <ul>
      <li>Bachelor's or Master's degree in Data Science, Statistics, Computer Science, or related field.</li>
      <li>2+ years of experience in data analysis or data science roles.</li>
      <li>Strong problem-solving and critical thinking skills.</li>
      <li>Excellent written and verbal communication skills.</li>
    </ul>
    <b>Technical Skill Set:</b>
    <ul>
      <li><b>Languages:</b> Python, R, SQL</li>
      <li><b>Libraries:</b> Pandas, NumPy, Scikit-learn, Matplotlib, Seaborn</li>
      <li><b>Machine Learning:</b> TensorFlow, PyTorch</li>
      <li><b>Data Visualization:</b> Power BI, Tableau</li>
      <li><b>Big Data:</b> Spark, Hadoop</li>
      <li><b>Databases:</b> MySQL, PostgreSQL, MongoDB</li>
    </ul>
    <br />
    <div class="apply-instructions">The candidates fulfilling the above mentioned criteria are encouraged to send their updated resumes at <a href="mailto:careers@trbai.com">careers@trbai.com</a>.</div><br><br>`
  },
  {
    title: "MERN Stack Developer",
    location: "Lahore, Pakistan",
    description: `
    We are looking for a skilled <b>MERN Stack Developer</b> to build modern web applications using MongoDB, Express, React, and Node.js. As a full-stack developer, you will be responsible for developing and maintaining scalable web applications that deliver exceptional user experiences. You will work closely with our design and product teams to translate requirements into functional, responsive web applications. This role requires expertise in both frontend and backend development, with a focus on creating robust, maintainable code and implementing best practices for web development. You will also be involved in code reviews, testing, and deployment processes to ensure high-quality deliverables.<br /><br />
    <b>Key Responsibilities:</b>
    <ul>
      <li>Develop and maintain scalable web applications using the MERN stack.</li>
      <li>Design and implement RESTful APIs.</li>
      <li>Collaborate with UI/UX designers and other developers.</li>
      <li>Write clean, maintainable, and efficient code.</li>
      <li>Participate in code reviews and testing.</li>
      <li>Troubleshoot and debug applications.</li>
    </ul>
    <b>Required Qualifications:</b>
    <ul>
      <li>Bachelor's degree in Computer Science or related field.</li>
      <li>2+ years of experience in full-stack web development.</li>
      <li>Strong understanding of web technologies and architectures.</li>
      <li>Good communication and teamwork skills.</li>
    </ul>
    <b>Technical Skill Set:</b>
    <ul>
      <li><b>Frontend:</b> React.js, Redux, HTML5, CSS3, JavaScript (ES6+)</li>
      <li><b>Backend:</b> Node.js, Express.js</li>
      <li><b>Database:</b> MongoDB</li>
      <li><b>Version Control:</b> Git</li>
      <li><b>APIs:</b> RESTful API development</li>
      <li><b>Tools:</b> Webpack, Babel, NPM</li>
    </ul>
    <br />
    <div class="apply-instructions">The candidates fulfilling the above mentioned criteria are encouraged to send their updated resumes at <a href="mailto:careers@trbai.com">careers@trbai.com</a>.</div><br><br>`
  },
  {
    title: "iOS Developer",
    location: "Lahore, Pakistan",
    description: `
    We are seeking an experienced <b>iOS Developer</b> to design and build advanced applications for the iOS platform. In this role, you will be responsible for developing high-quality, user-friendly iOS applications that meet our clients' needs and exceed their expectations. You will work closely with our design and product teams to create intuitive user interfaces and seamless user experiences. The ideal candidate will have a strong understanding of iOS development best practices, Apple's Human Interface Guidelines, and the latest iOS technologies. You will also be involved in the entire app development lifecycle, from concept and design to testing and deployment on the App Store.<br /><br />
    <b>Key Responsibilities:</b>
    <ul>
      <li>Design and build advanced applications for the iOS platform.</li>
      <li>Collaborate with cross-functional teams to define, design, and ship new features.</li>
      <li>Ensure the performance, quality, and responsiveness of applications.</li>
      <li>Identify and correct bottlenecks and fix bugs.</li>
      <li>Help maintain code quality, organization, and automatization.</li>
    </ul>
    <b>Required Qualifications:</b>
    <ul>
      <li>Bachelor's degree in Computer Science or related field.</li>
      <li>2+ years of experience in iOS development.</li>
      <li>Strong problem-solving skills and attention to detail.</li>
      <li>Excellent communication skills.</li>
    </ul>
    <b>Technical Skill Set:</b>
    <ul>
      <li><b>Languages:</b> Swift, Objective-C</li>
      <li><b>Frameworks:</b> UIKit, Core Data, Core Animation, Core Graphics</li>
      <li><b>Tools:</b> Xcode, Git</li>
      <li><b>APIs:</b> RESTful APIs, JSON</li>
      <li><b>App Store:</b> App Store submission and review process</li>
    </ul>
    <br />
    <div class="apply-instructions">The candidates fulfilling the above mentioned criteria are encouraged to send their updated resumes at <a href="mailto:careers@trbai.com">careers@trbai.com</a>.</div><br><br>`
  },
  {
    title: "Android Developer",
    location: "Lahore, Pakistan",
    description: `
    We are looking for a talented <b>Android Developer</b> to develop and maintain innovative mobile applications for Android devices. As an Android developer, you will be responsible for creating high-performance, scalable, and user-friendly mobile applications that provide exceptional user experiences. You will work closely with our design and product teams to implement cutting-edge features and ensure the highest quality standards. The ideal candidate will have a deep understanding of Android development best practices, Material Design principles, and the latest Android technologies. You will also be involved in the complete app development lifecycle, from planning and design to testing and deployment on the Google Play Store.<br /><br />
    <b>Key Responsibilities:</b>
    <ul>
      <li>Design and build advanced applications for the Android platform.</li>
      <li>Collaborate with cross-functional teams to define, design, and ship new features.</li>
      <li>Work with outside data sources and APIs.</li>
      <li>Unit-test code for robustness, including edge cases, usability, and general reliability.</li>
      <li>Troubleshoot, debug, and optimize application performance.</li>
    </ul>
    <b>Required Qualifications:</b>
    <ul>
      <li>Bachelor's degree in Computer Science or related field.</li>
      <li>2+ years of experience in Android development.</li>
      <li>Strong analytical and problem-solving skills.</li>
      <li>Good communication skills.</li>
    </ul>
    <b>Technical Skill Set:</b>
    <ul>
      <li><b>Languages:</b> Java, Kotlin</li>
      <li><b>Frameworks:</b> Android SDK, Jetpack</li>
      <li><b>Tools:</b> Android Studio, Git</li>
      <li><b>APIs:</b> RESTful APIs, JSON</li>
      <li><b>App Store:</b> Google Play submission and review process</li>
    </ul>
    <br />
    <div class="apply-instructions">The candidates fulfilling the above mentioned criteria are encouraged to send their updated resumes at <a href="mailto:careers@trbai.com">careers@trbai.com</a>.</div><br><br>`
  },
  {
    title: "HR Associate",
    location: "Lahore, Pakistan",
    description: `
    We are seeking a proactive <b>HR Associate</b> to support HR operations and help foster a positive workplace culture. In this role, you will be responsible for assisting with various HR functions including recruitment, employee relations, benefits administration, and HR policy implementation. You will work closely with the HR team to ensure smooth day-to-day operations and contribute to creating an engaging work environment. The ideal candidate will have excellent organizational skills, strong interpersonal abilities, and a passion for supporting employee growth and development. You will also be involved in maintaining employee records, coordinating training programs, and supporting the overall HR strategy of the organization.<br /><br />
    <b>Key Responsibilities:</b>
    <ul>
      <li>Assist in recruitment, onboarding, and employee engagement activities.</li>
      <li>Maintain employee records and HR documentation.</li>
      <li>Support payroll and benefits administration.</li>
      <li>Coordinate training and development programs.</li>
      <li>Address employee queries and support HR policies implementation.</li>
    </ul>
    <b>Required Qualifications:</b>
    <ul>
      <li>Bachelor's degree in Human Resources, Business Administration, or related field.</li>
      <li>1+ years of experience in HR or administrative roles.</li>
      <li>Excellent organizational and interpersonal skills.</li>
      <li>Strong written and verbal communication skills.</li>
    </ul>
    <b>Skill Set:</b>
    <ul>
      <li>HRIS systems</li>
      <li>MS Office Suite</li>
      <li>Recruitment tools</li>
      <li>Payroll and benefits administration</li>
      <li>Employee engagement</li>
    </ul>
    <br />
    <div class="apply-instructions">The candidates fulfilling the above mentioned criteria are encouraged to send their updated resumes at <a href="mailto:careers@trbai.com">careers@trbai.com</a>.</div><br><br>`
  },
];